export default __webpack_public_path__ + "35276ecdfc47ab3e56c47060030770b6.jpg";